import logoPlusMinusSystems from "../assets/images/logoplusminussystems.svg";
import logoMaimaSoft from "../assets/images/logomaimasoft.svg";
import config from "../Config";

/** Built-in company logos packaged with the frontend (used on login + School Info). */
export const COMPANY_LOGO_PRESETS = [
  {
    fileName: "logoplusminussystems.svg",
    label: "Plus Minus Systems",
    src: logoPlusMinusSystems,
  },
  {
    fileName: "logomaimasoft.svg",
    label: "Maima Soft",
    src: logoMaimaSoft,
  },
];

export const DEFAULT_COMPANY_LOGO = logoPlusMinusSystems;
export const DEFAULT_COMPANY_LOGO_FILE = "logoplusminussystems.svg";

export function isCompanyLogoPreset(fileName) {
  if (!fileName) return false;
  return COMPANY_LOGO_PRESETS.some((p) => p.fileName === fileName);
}

export function resolveCompanyLogoSrc(fileName) {
  if (!fileName) {
    return DEFAULT_COMPANY_LOGO;
  }
  const preset = COMPANY_LOGO_PRESETS.find((p) => p.fileName === fileName);
  if (preset) {
    return preset.src;
  }
  return `${config.images}${fileName}?t=${Date.now()}`;
}
